import i18n from "src/app/shared/localization/i18n";

export const FILE_MAX_SIZE: number = 20 * 1024 * 1024;
export const FILE_MAX_SIZE_MESSAGE: string = i18n.t("error.fileMaxSize", {maxSize: 20});
export const CHAT_NAME_MAX_LENGTH: number = 50;
export const CLIENT_NAME_MAX_LENGTH: number = 30;
export const COMMENT_MAX_LENGTH: number = 50000;
export const FILE_SIZE_WARNING: number = 8 * 1024 * 1024;